var map = {
	"./subject-0.svg": "bee1",
	"./subject-1.svg": "7fa6",
	"./subject-10.svg": "cae9",
	"./subject-11.svg": "f4b5",
	"./subject-12.svg": "7113",
	"./subject-13.svg": "8506",
	"./subject-14.svg": "6907",
	"./subject-15.svg": "2443",
	"./subject-16.svg": "4216",
	"./subject-17.svg": "965b",
	"./subject-18.svg": "19f1",
	"./subject-2.svg": "bc31",
	"./subject-3.svg": "adfe",
	"./subject-4.svg": "e226",
	"./subject-5.svg": "3719",
	"./subject-6.svg": "95bd",
	"./subject-7.svg": "8d30",
	"./subject-8.svg": "0f91",
	"./subject-9.svg": "d992"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a732";